import { render, staticRenderFns } from "./DangerousPermissions.vue?vue&type=template&id=3e52c0fc"
import script from "./DangerousPermissions.vue?vue&type=script&lang=js"
export * from "./DangerousPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports